import { useTranslation } from 'next-i18next';

import { Slider } from '@phoenix/design-system/frontend/ui/slider/slider';
import { useBreakpoints } from '@phoenix/design-system/frontend/ui/breakpoints/use-breakpoints';

import {
  PromotionalHeader,
  PromotionalImage,
  CompatibleProductsWithPlaceholders,
} from '@phoenix/team-m/dashboard/frontend/ui/from-the-shop/compatible-products';
import { OverviewSubsection } from '@phoenix/team-m/dashboard/frontend/ui/overview/overview-subsection';
import { useEditorialCardSliderOptions } from '@phoenix/team-m/dashboard/frontend/shared/use-editorial-card-slider-options';
import { ProductRecommendedCard } from '@phoenix/team-m/dashboard/frontend/ui/from-the-shop/product-recommendation/product-recommended-card';

import { CompatibleProduct } from './use-compatible-products';

export const CompatibleProducts = ({ products }: { products?: CompatibleProduct[] }) => {
  const { t } = useTranslation();
  const sliderOptions = useEditorialCardSliderOptions();
  const { tablet, desktop } = useBreakpoints();

  return products?.length ? (
    <OverviewSubsection dataTestId="compatible-products">
      <div className="grid grid-cols-3 gap-6">
        <PromotionalHeader
          headline={t('dashboard_compatibleProducts_teaser_headline')}
          description={t('dashboard_compatibleProducts_teaser_copy')}
          className="col-span-3 desktop:col-span-2"
          imageSrc="battery-promotion.jpeg"
        />
        <PromotionalImage className="hidden desktop:block" />
      </div>
      {(tablet && products.length === 1) || (desktop && products.length < 3) ? (
        <CompatibleProductsWithPlaceholders products={products} />
      ) : (
        <Slider
          id="battery-compatible-products"
          className="mt-6"
          sliderOptions={sliderOptions}
          dataTestId="battery-compatible-products"
          touchStartPreventDefault={false}
        >
          {products.map((product, i) => (
            <ProductRecommendedCard key={product.articleNumber} {...product} index={i + 1} />
          ))}
        </Slider>
      )}
    </OverviewSubsection>
  ) : null;
};
